import { browserHistory } from 'react-router';
import { handleReponse } from 'actions';
import fetchAPI from 'utils/fetchAPI';
import fetchDialCode from 'utils/fetchDialCode';

export const CLEAR_USER = 'CLEAR_USER';
export const UPDATE_USER_DIAL_CODE = 'UPDATE_USER_DIAL_CODE';
export const REQUEST_USER = 'REQUEST_USER';
export const RECEIVE_USER = 'RECEIVE_USER';
export const RECEIVE_USER_FAIL = 'RECEIVE_USER_FAIL';
export const REQUEST_USER_COMPANIES = 'REQUEST_USER_COMPANIES';
export const RECEIVE_USER_COMPANIES = 'RECEIVE_USER_COMPANIES';

export function clearUser() {
  return {
    type: CLEAR_USER,
  };
}

function updateUserDialCode(dialCode) {
  return {
    type: UPDATE_USER_DIAL_CODE,
    dialCode,
  };
}

function requestUser() {
  return {
    type: REQUEST_USER,
  };
}

function receiveUser(token, user) {
  return {
    type: RECEIVE_USER,
    token,
    user,
  };
}

function receiveUserFail(errorMessage, errorCode) {
  return {
    type: RECEIVE_USER_FAIL,
    errorMessage,
    errorCode,
  };
}

export function login(phoneNumber, password, transitionTo = '/') {
  return (dispatch, getState) => {
    dispatch(requestUser());
    return fetchAPI({
      endpoint: '/login',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        phone_number: phoneNumber,
        password,
      }),
    })
      .then(response => response.json())
      .then(
        json =>
          new Promise((resolve, reject) => {
            if (json.error_message) {
              return reject(
                dispatch(receiveUserFail(json.error_message, json.error_code))
              );
            }
            return resolve(
              dispatch(
                receiveUser(
                  json.data.token,
                  Object.assign(
                    {},
                    { admin: json.data.is_admin, staff: json.data.is_staff },
                    json.data.user
                  )
                )
              )
            );
          })
      )
      .then(() => browserHistory.push(transitionTo));
  };
}

export function getUserDialCodeIfNeeded() {
  return (dispatch, getState) => {
    if (getState().users.country) {
      return;
    }
    fetchDialCode().then(dialCode => {
      dispatch(updateUserDialCode(dialCode));
    });
  };
}

export function sendVerificationCode(body) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const endpoint =
        Object.keys(body).indexOf('email') !== -1 ? '/forgot/email' : '/forgot';
      fetchAPI({
        endpoint,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      }).then(res => {
        if (res.status === 404) {
          reject('USER_NONEXISTS');
        }
        if (res.status === 200) {
          return res.json().then(json => resolve(json.data.id));
        }
        return reject('INVALID_INFORMATION_PROVIDED');
      });
    });
}

export function verifyNewPassword({ id, verification_code, password }) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      fetchAPI({
        endpoint: '/forgot/verify',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ id, verification_code, password }),
      }).then(res => {
        if (res.status === 200) {
          res.json().then(json => resolve(json.token));
        }
        return res.json().then(json => {
          if (json.error_code) {
            return reject(json.error_message);
          }
          return reject('INVALID_VERIFICATION_CODE');
        });
      });
    });
}

const requestUserCompanies = () => ({
  type: REQUEST_USER_COMPANIES,
});

const receiveUserCompanies = ({ companies }) => ({
  type: RECEIVE_USER_COMPANIES,
  companies,
});

export const getEnterpriseAccess = () => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    dispatch(requestUserCompanies());
    fetchAPI({
      endpoint: '/self/companies/access',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => handleReponse(res, dispatch))
      .then(
        json => {
          dispatch(receiveUserCompanies({ companies: json.data }));
          return resolve(json.data);
        },
        error => reject(error)
      );
  });

export const retrieveUserInfoById = id => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/users/${id}`,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => handleReponse(res, dispatch))
      .then(json => resolve(json.data), error => reject(error));
  });



// WEBPACK FOOTER //
// ./app/actions/UserActionCreators.js